import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { map } from 'rxjs/operators';
import { NotificationService } from '../services/notification.service';
import { isPlatformBrowser } from '@angular/common';
import { logoutUser } from 'src/app/theme/utils/feature-tag';

@Injectable({
  providedIn: 'root'
})
export class VerifyTokenGuard implements CanActivate {
  private storageEventListener: () => void;
  constructor(
    private apiService: ApiService, 
    private router: Router, 
    private notification: NotificationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { 
    if(isPlatformBrowser(this.platformId)){
      this.storageEventListener = this.handleStorageChange.bind(this);
      window.addEventListener('storage', this.storageEventListener);
    }
  }
  handleStorageChange(event: StorageEvent) {
    if (event.key === 'token') {
      // When the logged-in user changes, we refresh the current tab to reflect the new session
      window.location.reload();
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('storage', this.storageEventListener);
    }
  }

  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const signInId = next.queryParams['id'];
    const isSignInRoute = state.url.includes('sign-in');

    if (signInId && isSignInRoute) {      
      localStorage.clear();
      sessionStorage.clear();
    }

    if (this.apiService.loggedIn()) {
      return this.apiService.verifyToken().pipe(map(data => {
        if (data['response']['status'] === 22) {
          // sessionStorage.clear();
          logoutUser(this.apiService, this.router, this.notification)
          return false;
        } else {
          return true;
        }
      }, (err: any) => console.log('verify token error : ', err)))
    }else {
      return true;
    }

  }

}
